"use client";

import { CheckCircle, Info, WarningCircle } from "@/components/shared/icons";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast/toast";
import { useToast } from "@/components/ui/toast/use-toast";

export function Toaster() {
  const { toasts } = useToast();

  const getToastIconVariant = ({ variant }: { variant: string }) => {
    switch (variant) {
      case "info":
        return <Info weight="fill" className="text-info h-[20px] w-[20px]" />;
      case "success":
        return <CheckCircle weight="fill" className="text-success h-[20px] w-[20px]" />;
      case "error":
        return <WarningCircle weight="fill" className="text-danger h-[20px] w-[20px]" />;
      case "warning":
        return <WarningCircle weight="fill" className="text-warning h-[20px] w-[20px]" />;
      default:
        return <Info weight="fill" className="text-info h-[20px] w-[20px]" />;
    }
  };

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              <div className="flex flex-row items-center gap-3">
                {getToastIconVariant({ variant: variant ?? "info" })}
                {title && <ToastTitle>{title}</ToastTitle>}
              </div>
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
